import React from 'react';

//forms
import FormHeader from "../../../form/ModamilyAppFormHeader";
import ButtonGroup from "../../../form/ModamilyAppButtonGroup";

// cosntants
import Options from "../../../../constants/formOptions";

const Ethnicity = ({ searchPreferences, handleUpdate, selectedEthnicityIndexes }) => (
  <div className="searchPrefForm">
		<div className="searchPrefIncomeRangeFormContainer">
			<FormHeader text="Ethnicity" />
			<ButtonGroup
				manualSelection={true}
				customSelected={selectedEthnicityIndexes}
				data={Options.ethnicities}
				onButtonClick={(value, index) => {
					if (index > -1) {
						if(value.toLowerCase() === 'prefer not to say') {
							searchPreferences.ethnicity = [value.toLowerCase()]
						} else {
							const indexOfPNTS = searchPreferences.ethnicity.indexOf('prefer not to say');
							if ( indexOfPNTS > -1) { 
								searchPreferences.ethnicity.splice(
									indexOfPNTS,
									1
								);
							}
							searchPreferences.ethnicity.push(
								value.toLowerCase()
							);
						}
					} else {
						searchPreferences.ethnicity.splice(
							searchPreferences.ethnicity.indexOf(
								value.toLowerCase()
							),
							1
						);
					}
					handleUpdate(searchPreferences);
				}}
			/>
		</div>
	</div>
);

export default Ethnicity;